
import TheNavBar from "./components/TheNavBar.vue";
export default {
  name: "App",
  components: { TheNavBar },
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION as string | undefined,
    };
  },
};
